import React, { useEffect, useRef } from 'react';
import './Marquee.css';

const Marquee = () => {
  const marqueeRef = useRef(null);
  const items = [
    'FMGE / NEXT Ready', 'WHO Approved', 'International Recognized', 'Hassle-Free Process',
    'Unbiased Counselling', 'Budget Friendly', 'Low Cost | High Quality', 'Pick and drop facility',
    'Free Flight Ticket', '24hr Response', '2500+ Students Placed'
  ];

  useEffect(() => {
    const track = marqueeRef.current;
    if (track) {
      track.innerHTML = '';
      [...items, ...items].forEach(text => {
        const div = document.createElement('div');
        div.className = 'mi';
        div.innerHTML = `<span class="mi-dot"></span>${text}`;
        track.appendChild(div);
      });
    }
  }, []);

  return (
    <div className="marquee-bar">
      <div className="marquee-inner" ref={marqueeRef}></div>
    </div>
  );
};

export default Marquee;